import { ProppantTypeBase } from './base/proppant-type-base';

export class ProppantType extends ProppantTypeBase { }